import { forwardRef } from 'preact/compat';
import { cssProps } from '@oracle/oraclejet-cssprops';
import { HTMLAttributesSignalExcluded } from '../utils/UNSAFE_attributeUtils';

type IntrinsicProps = Pick<HTMLAttributesSignalExcluded<HTMLDivElement>, 'children'>;
type Props = IntrinsicProps;

const styles = {
  base: cssProps`${{
    position: 'absolute',
    inset: 0,
    backgroundColor: 'transparent',
    height: '100%',
    margin: '0 auto',
    maxWidth: 'calc(100% - 0.01px) !important',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }}`
};

const ModalContainer = forwardRef<HTMLDivElement, Props>(({ children }, ref) => (
  <div class={styles.base} ref={ref}>
    {children}
  </div>
));
ModalContainer.displayName = 'Forwarded<ModalContainer>';

export default ModalContainer;
